import e from "../../managers/braze-instance.js";
import { destroyFeedHtml as k } from "../../common/feed-display.js";
export function destroyFeed() {
  if (!e.rr()) return;
  const o = document.querySelectorAll(".ab-feed");
  for (let e = 0; e < o.length; e++) k(o[e]);
}
